document.documentElement.classList.remove('no-js');
const menuButton = document.querySelector('.menu-button');
const siteNav = document.querySelector('#SiteNav');
if (menuButton && siteNav) {
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    siteNav.classList.toggle('is-open', !open);
  });
}

const variantSelect = document.querySelector('#VariantSelect');
const quantityInput = document.querySelector('#Quantity');
const inventoryMessage = document.querySelector('.inventory-limit');
if (variantSelect && quantityInput) {
  const syncInventoryLimit = () => {
    const available = variantSelect.selectedOptions[0]?.dataset.inventory;
    if (available !== undefined) {
      const limit = Math.max(0, Number(available));
      quantityInput.max = String(limit);
      if (Number(quantityInput.value) > limit) quantityInput.value = String(Math.max(1, limit));
      if (inventoryMessage) inventoryMessage.textContent = limit > 0 ? `Only ${limit} available` : 'Sold out';
    } else {
      quantityInput.removeAttribute('max');
      if (inventoryMessage) inventoryMessage.textContent = '';
    }
  };
  variantSelect.addEventListener('change', syncInventoryLimit);
  quantityInput.addEventListener('change', () => {
    if (quantityInput.max && Number(quantityInput.value) > Number(quantityInput.max)) quantityInput.value = quantityInput.max;
  });
  syncInventoryLimit();
}

const drawerSection = () => document.querySelector('#shopify-section-cart-drawer');
const openCartDrawer = () => {
  document.body.classList.add('cart-drawer-open');
  document.querySelector('.cart-drawer')?.focus();
};
const closeCartDrawer = () => document.body.classList.remove('cart-drawer-open');
const refreshCartDrawer = async () => {
  const response = await fetch('/?sections=cart-drawer');
  const sections = await response.json();
  const holder = document.createElement('div');
  holder.innerHTML = sections['cart-drawer'];
  const fresh = holder.querySelector('#shopify-section-cart-drawer');
  const current = drawerSection();
  if (fresh && current) current.innerHTML = fresh.innerHTML;
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();
  document.querySelectorAll('.cart-count').forEach((badge) => { badge.textContent = cart.item_count; });
};

document.addEventListener('click', async (event) => {
  const cartLink = event.target.closest('.cart-link');
  if (cartLink && !event.ctrlKey && !event.metaKey) {
    event.preventDefault();
    openCartDrawer();
    return;
  }
  if (event.target.closest('[data-cart-close]')) {
    closeCartDrawer();
    return;
  }
  const removeLink = event.target.closest('.drawer-remove');
  if (removeLink) {
    event.preventDefault();
    await fetch(removeLink.href);
    await refreshCartDrawer();
    openCartDrawer();
  }
});

document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCartDrawer(); });

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to add this treasure.');
      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
});

const searchShell = document.querySelector('.search-overlay-shell');
const searchInput = document.querySelector('#OverlaySearchInput');
const searchResults = document.querySelector('.predictive-results');
const searchAllLink = document.querySelector('.search-all-link');
const openSearch = () => {
  document.body.classList.add('search-overlay-open');
  window.setTimeout(() => searchInput?.focus(), 80);
};
const closeSearch = () => document.body.classList.remove('search-overlay-open');
let searchTimer;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.search-trigger');
  if (trigger && !event.ctrlKey && !event.metaKey) { event.preventDefault(); openSearch(); }
  if (event.target.closest('[data-search-close]')) closeSearch();
});
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSearch(); });

if (searchInput && searchResults) {
  searchInput.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    const query = searchInput.value.trim();
    searchAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    if (query.length < 2) { searchResults.replaceChildren(); return; }
    searchTimer = window.setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide`);
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        searchResults.replaceChildren();
        products.forEach((product) => {
          const card = document.createElement('a'); card.className = 'predictive-card'; card.href = product.url;
          if (product.featured_image?.url || product.image) { const img = document.createElement('img'); img.src = product.featured_image?.url || product.image; img.alt = product.featured_image?.alt || product.title; card.append(img); }
          const title = document.createElement('strong'); title.textContent = product.title; card.append(title);
          const price = document.createElement('span'); price.textContent = new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(product.price)); card.append(price);
          searchResults.append(card);
        });
        if (!products.length) { const empty = document.createElement('p'); empty.className = 'predictive-empty'; empty.textContent = 'No tiny treasures found yet. Try another magical word.'; searchResults.append(empty); }
      } catch (_) { searchResults.textContent = 'Search is resting for a moment. Please try again.'; }
    }, 250);
  });
}

document.querySelectorAll('[data-tag-toggle]').forEach((toggle) => {
  const tagList = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!tagList) return;
  toggle.addEventListener('click', () => {
    const expanded = tagList.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Show fewer tags' : 'Show all tags';
  });
});
